import { useEffect } from 'react';
import { useAuthStore } from '@/lib/core/stores/useAuthStore';
import { isTokenExpired } from '@/lib/core/utils/dateTime';
import { refreshToken } from '@/services/platform/data/authentication';

const REFRESH_BEFORE_MS = 2 * 60 * 1000;

export function useTokenRefresh() {
  const expiresAt = useAuthStore(state => state.expiresAt);
  const accessToken = useAuthStore(state => state.accessToken);

  useEffect(() => {
    if (!accessToken || !expiresAt) return;

    if (isTokenExpired(expiresAt)) {
      refreshToken();
      return;
    }

    const msUntilExpiry = new Date(expiresAt).getTime() - Date.now();
    const delay = Math.max(0, msUntilExpiry - REFRESH_BEFORE_MS);
    const timer = setTimeout(() => {
      refreshToken();
    }, delay);
    return () => clearTimeout(timer);
  }, [accessToken, expiresAt]);
}
